import moment from 'moment';

const yearSensitiveDateString = (
  timestamp: Date | string,
  format = 'MMMM D',
  compare: number | Date = moment().valueOf(),
) => {
  const timestampMoment = moment(timestamp);
  const compareMoment = moment(compare);
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const showYear = timestampMoment.year() !== compareMoment.year();
  return timestampMoment.format(showYear ? `${format}, YYYY` : format);
};

export default yearSensitiveDateString;
